export const EMPTY_PLACEHOLDER = '- -'

export const isEmptyTableValue = value => {
  return (!value && value !== 0) || value === EMPTY_PLACEHOLDER
}

export const maskMap = {
  INTEGER: ['###'],
  FLOAT: ['###.##', '##.##', '#.##']
}
